/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkip2ForwardIcon20Solid = forwardRef('MediaUiASkip2ForwardIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M20 4a1 1 0 1 0-2 0v4.455l-6.583-5.087C10.431 2.606 9 3.308 9 4.555v3.9L2.417 3.368C1.431 2.606 0 3.308 0 4.555v10.89c0 1.246 1.431 1.95 2.417 1.187L9 11.545v3.9c0 1.246 1.431 1.95 2.417 1.187L18 11.545V16a1 1 0 1 0 2 0V4Z" })));
});
